import React from 'react'
import classNames from 'classnames'
import propTypes from 'prop-types'
import { FaInbox } from 'react-icons/fa'
import _ from 'lodash'
import InfiniteScroll from 'react-infinite-scroller'

import { Composition } from './Composition'
import FullScreenMessage from 'components/FullScreenMessage'
import Loader from 'components/Loader'


export function Compositions(props) {
  if ( ! props.loading && props.items.length === 0) {
    return (
      <FullScreenMessage icon={<FaInbox className='text-4xl' />}>
        <span>No compositions found.</span>
      </FullScreenMessage>
    )
  }

  return (
    <div className={classNames([
      'max-w-3xl ml-auto mr-auto',
      props.className,
    ])}>
      <InfiniteScroll
        className='pb-20'
        loadMore={props.loadMore}
        hasMore={props.hasMore}
        loader={
          props.items.length !== 0 &&
          <p key={0} className='text-center pt-10'>
            <Loader className='text-center inline-block' active />
          </p>
        }
      >
        {
          _.map(
            _.orderBy(props.items, 'createdAt', 'desc'),
            item => (
              <Composition {...item} key={`composition_${item.id}`}/>
            )
          )
        }
      </InfiniteScroll>
    </div>
  )
}

Compositions.propTypes = {
  className: propTypes.string,
  items: propTypes.array.isRequired,
  loading: propTypes.bool,
  hasMore: propTypes.bool.isRequired,
  loadMore: propTypes.func.isRequired,
}

Compositions.defaultProps = {
  loading: false,
}
